import posthog, { PostHogConfig } from 'posthog-js';
import { PostHogProvider as PostHogProviderJs } from 'posthog-js/react';
import { useEffect, useState } from 'react';

import { PostHogUserIdentifier } from './PostHogUserIdentifier';

const posthogApiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const postHogOptions: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  person_profiles: 'always',
  advanced_disable_feature_flags_on_first_load: true,
};

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    if (posthogApiKey && typeof window !== 'undefined') {
      posthog.init(posthogApiKey, postHogOptions);
      setHydrated(true);
    }
  }, []);

  if (!hydrated) return <>{children}</>;

  return (
    <PostHogProviderJs client={posthog}>
      <PostHogUserIdentifier />
      {children}
    </PostHogProviderJs>
  );
}
